import React from 'react'
import '../assets/Project.css';
import WorkData from "./WorkData.js"
import WorkCard from "./WorkCard.js"

class Work extends React.Component {
  render() {
    return (
    <section id="Project">
     <div className="container">
        <h1 data-aos="fade-right"><b>My projects</b></h1>
       <div className="underline_brick"></div><br />
         <div className="others row  row-cols-1 row-cols-sm-2 row-cols-md-3 g-3">
            {WorkData.map((ide, num) =>{
               return (
                   <WorkCard
                       key={num}
                       worknumber={ide.worknumber}
                       project_type={ide.project_type}
                       title={ide.title}
                       text={ide.text}
                       link={ide.link}
                       language={ide.language}
                   />
               )
           })}
       </div>
     </div>
    </section>
    )
  }
}

export default Work;
